import { render, staticRenderFns } from "./enlightenment.vue?vue&type=template&id=9aa4844c&scoped=true&"
import script from "./enlightenment.vue?vue&type=script&lang=js&"
export * from "./enlightenment.vue?vue&type=script&lang=js&"
import style0 from "./enlightenment.vue?vue&type=style&index=0&id=9aa4844c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9aa4844c",
  null
  
)

export default component.exports